import { Progress } from "ant-design-vue"
const { ...other } = Progress
const YwProgress = {
  ...other,
  name: "YwProgress",
}
YwProgress.install = function (Vue) { 
  Vue.component(YwProgress.name, Progress);
}
export default YwProgress